var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(-76)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_Copy_17",
    "data-name": "Rectangle Copy 17",
    width: 48,
    height: 48,
    rx: 24,
    transform: "translate(76)",
    fill: "#eb742e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(83 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M32.174,29H.826a.843.843,0,0,1-.585-.236A.8.8,0,0,1,0,28.2V10.472a.8.8,0,0,1,.4-.688.044.044,0,0,1,.024-.009.061.061,0,0,0,.022-.006l0-.009L4.95,7.442V.806a.8.8,0,0,1,.241-.57A.843.843,0,0,1,5.776,0H27.224a.843.843,0,0,1,.585.236.8.8,0,0,1,.241.57V7.442l4.509,2.318v.011l.018,0a.067.067,0,0,1,.023.007.8.8,0,0,1,.4.688V28.2a.8.8,0,0,1-.241.569A.843.843,0,0,1,32.174,29ZM1.651,11.807V27.388h29.7V11.807L16.884,19.241a.837.837,0,0,1-.768,0ZM6.6,1.612V12.531l9.9,5.087,9.9-5.087V1.612ZM4.95,9.262,2.6,10.472,4.95,11.682Zm23.1,0v2.419l2.353-1.21Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b53b2ac90c2eed911dbf1fe1404fea4f.svg";
export { ForwardRef as ReactComponent };